import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import DashboardIcon from '@mui/icons-material/Dashboard'
import NotificationsIcon from '@mui/icons-material/Notifications'
import SettingsInputSvideoIcon from '@mui/icons-material/SettingsInputSvideo'
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart'
import TuneIcon from '@mui/icons-material/Tune'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { Link } from '../../router/components/Link'

interface Props {
  onItemClick: () => void
}

export const HoofdleidingMenu = ({ onItemClick }: Props) => {
  const {
    canViewProjecten,
    canViewActiviteiten,
    canViewAssignedBijlagen,
    canViewBalkenplanning,
  } = useAuthenticatedUser()

  const shouldRender =
    canViewProjecten ||
    canViewActiviteiten ||
    canViewAssignedBijlagen ||
    canViewBalkenplanning

  return shouldRender ? (
    <>
      <List subheader={<ListSubheader>Hoofdleiding</ListSubheader>}>
        {canViewProjecten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/dashboard"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        )}

        {canViewProjecten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/projecten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <SettingsInputSvideoIcon />
            </ListItemIcon>
            <ListItemText primary="Projecten" />
          </ListItemButton>
        )}

        {canViewBalkenplanning && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/planning"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <StackedBarChartIcon
                sx={{ transform: 'rotate(90deg) scaleX(-1)' }}
              />
            </ListItemIcon>
            <ListItemText primary="Planning" />
          </ListItemButton>
        )}

        {canViewActiviteiten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/activiteiten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <NotificationsIcon />
            </ListItemIcon>
            <ListItemText primary="Activiteiten" />
          </ListItemButton>
        )}

        {canViewAssignedBijlagen && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/bijlagen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AttachFileIcon />
            </ListItemIcon>
            <ListItemText primary="Bijlagen" />
          </ListItemButton>
        )}

        {canViewAssignedBijlagen && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/subprocessen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AccountTreeIcon />
            </ListItemIcon>
            <ListItemText primary="Subprocessen" />
          </ListItemButton>
        )}

        {canViewProjecten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdleiding/contractinstellingen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <TuneIcon />
            </ListItemIcon>
            <ListItemText primary="Contractinstellingen" />
          </ListItemButton>
        )}
      </List>

      <Divider />
    </>
  ) : null
}
